import {
  Attachment,
  AttachmentModel,
} from '@digital-platform/attachments/domain';
import { DomainModelHelper } from '@digital-platform/shared/domain';
import { LabAnalyticalAttachment } from '../interfaces';

interface LabAnalyticalAttachmentSample {
  readonly idNumber: string;
  readonly sampleDate: Date;
}

export class LabAnalyticalAttachmentModel implements LabAnalyticalAttachment {
  readonly attachment: Attachment;
  readonly samples: LabAnalyticalAttachmentSample[];
  readonly sampleType: 'composite' | 'grab' | 'compositeAndGrab';
  readonly sampleEpaCompliant: string;

  public static DEFAULT_CONFIG: LabAnalyticalAttachment = {
    attachment: AttachmentModel.DEFAULT_CONFIG,
    samples: [],
    sampleType: null,
    sampleEpaCompliant: '',
  };

  constructor(config?: LabAnalyticalAttachment) {
    this.attachment = config
      ? config.attachment
        ? new AttachmentModel(config.attachment)
        : LabAnalyticalAttachmentModel.DEFAULT_CONFIG.attachment
      : LabAnalyticalAttachmentModel.DEFAULT_CONFIG.attachment;
    this.samples = config
      ? this.createSamples(config.samples)
      : LabAnalyticalAttachmentModel.DEFAULT_CONFIG.samples;
    this.sampleType = config
      ? this.convertToSampleType(config.sampleType)
      : LabAnalyticalAttachmentModel.DEFAULT_CONFIG.sampleType;
    this.sampleEpaCompliant = config
      ? DomainModelHelper.ensureDataIsString(config.sampleEpaCompliant)
      : LabAnalyticalAttachmentModel.DEFAULT_CONFIG.sampleEpaCompliant;
  }

  protected convertToSampleType(
    sampleType: string
  ): LabAnalyticalAttachmentModel['sampleType'] {
    switch ((sampleType || '').toLocaleLowerCase()) {
      case 'composite':
        return 'composite';
      case 'grab':
        return 'grab';
      case 'compositeandgrab':
        return 'compositeAndGrab';
      default:
        return null;
    }
  }

  protected createSamples(
    samples: LabAnalyticalAttachmentSample[]
  ): LabAnalyticalAttachmentSample[] {
    if (!Array.isArray(samples)) {
      return [];
    }

    return samples.map((sample) => ({
      idNumber: DomainModelHelper.ensureDataIsString(sample.idNumber),
      sampleDate: DomainModelHelper.ensureDataIsDate(sample.sampleDate),
    }));
  }
}
